import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { transformRequest } from "../../../utils/API/requestMiddleware";
import { encryptAES } from "../../../services/CryptoService";

const EventManagementApi = createApi({
    reducerPath: 'EventManagementApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getEventDetailList: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/GetEventDetailList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropDownForEventManagement: builder.query({
            query: () => ({
                url: `/EventManagement/GetAllDropDownForEventManagement`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEventDetailsById: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/DeleteEventDetailById',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddEditEventDetails: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/AddEditEventDetails',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddEditEventLessonTimeSlotDetails: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/AddEditEventLessonTimeSlotDetails',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetLessonTimeSlotDetailsById: builder.query({
            query: (details) => ({
                url: `/EventManagement/GetLessonTimeSlotDetailsById?id=${encryptAES(details.eventId)}`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCancellationReasonForCreditNote: builder.query({
            query: () => ({
                url: `/EventManagement/GetCancellationReasonForCreditNote`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadBookingSheetByEventId: builder.query({
            query: (details) => ({
                url: `/EventManagement/DownloadBookingSheetByEventId?id=${details.eventId}&id2=${details.eventTimeSlotId}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        DeleteEventTimeSlotById: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/DeleteEventTimeSlotById',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddEditEventPricingDetail: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/AddEditEventPricingDetail',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddEditOtherEventDetails: builder.mutation({
            query: (details) => ({
                url: '/EventManagement/AddEditOtherEventDetails',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        GetIPASAddressesForEntries: builder.query({
            query: () => ({
                url: `/EventManagement/GetIPASAddressesForEntries`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useGetEventDetailListMutation,
    useLazyGetAllDropDownForEventManagementQuery,
    useDeleteEventDetailsByIdMutation,
    useAddEditEventDetailsMutation,
    useAddEditEventLessonTimeSlotDetailsMutation,
    useLazyGetLessonTimeSlotDetailsByIdQuery,
    useLazyGetCancellationReasonForCreditNoteQuery,
    useLazyDownloadBookingSheetByEventIdQuery,
    useDeleteEventTimeSlotByIdMutation,
    useAddEditEventPricingDetailMutation,
    useAddEditOtherEventDetailsMutation,
    useLazyGetIPASAddressesForEntriesQuery

} = EventManagementApi;

export default EventManagementApi;